import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Building2, TrendingUp, Users, Check, Clock, FileText } from 'lucide-react';
import { Button } from '../components/Button';
export function Services() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  const ServiceSection = ({
    id,
    title,
    code,
    description,
    icon: Icon,
    features,
    idealFor,
    deliverables,
    timeline,
    requirements
  }: any) => <section id={id} className="py-20 border-b border-gray-100 last:border-0" data-id="element-460" data-mp="65rah0mt7etr">
      <div className="container-custom" data-id="element-461" data-mp="2cw78cbrhg2hf">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-462" data-mp="2cx8upcdy8beg">
          {/* Left Column: Header & Description */}
          <div className="lg:col-span-4" data-id="element-463" data-mp="16p2xwiw8m64n">
            <div className="bg-blue-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-464" data-mp="16qe0ifdy57u6">
              <Icon className="h-8 w-8 text-blue-800" data-id="element-465" data-mp="1bofi0vvq4z3j" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-466" data-mp="1fp94dktiq5ub">{title}</h2>
            <p className="text-sm font-mono text-gray-500 mb-6" data-id="element-467" data-mp="1kfzd9815kqtr">
              Activity Code: {code}
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-468" data-mp="1pg3u4z5z3nki">{description}</p>
            <Link to="/contact" data-id="element-469" data-mp="1ue5bnfnr3etv">
              <Button className="w-full sm:w-auto" data-id="element-470" data-mp="1udcaqvbh3jjn">Request a Proposal</Button>
            </Link>
          </div>

          {/* Right Column: Details */}
          <div className="lg:col-span-8" data-id="element-471" data-mp="23f3i04lnvyfm">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8" data-id="element-472" data-mp="23e27q2cgzfyy">
              {/* Key Services */}
              <div className="mb-10" data-id="element-473" data-mp="51a8n1h5qv7j">
                <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-474" data-mp="90st5w52h49u">
                  Key Services
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-475" data-mp="1cb6nohwyunt5">
                  {features.map((feature: string, idx: number) => <div key={idx} className="flex items-start" data-id="element-476" data-mp="17epxzja4c1dy" data-mpi={idx}>
                      <Check className="h-5 w-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-477" data-mp="1ldpm8ptpye9l" />
                      <span className="text-gray-700" data-id="element-478" data-mp="1hatbflaf7mg7">{feature}</span>
                    </div>)}
                </div>
              </div>

              {/* Grid Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-479" data-mp="1qc9cv3j9ce8a">
                <div data-id="element-480" data-mp="1q9wtqn1rjxtn">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center" data-id="element-481" data-mp="2515gmoea7533">
                    <Users className="h-4 w-4 mr-2 text-blue-600" data-id="element-482" data-mp="201kkelqhxau2" /> Ideal For
                  </h4>
                  <ul className="space-y-2" data-id="element-483" data-mp="2e1bsy6y8tz0o">
                    {idealFor.map((item: string, idx: number) => <li key={idx} className="text-sm text-gray-600 flex items-start" data-id="element-484" data-mp="292r04slbmhm9" data-mpi={idx}>
                        <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-2 mt-1.5" data-id="element-485" data-mp="2slxxrbgeduw0"></span>
                        {item}
                      </li>)}
                  </ul>
                </div>

                <div data-id="element-486" data-mp="2noxwreyenibr">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center" data-id="element-487" data-mp="2no6a4tmscuxm">
                    <FileText className="h-4 w-4 mr-2 text-blue-600" data-id="element-488" data-mp="29x151c0nfafw" />{' '}
                    Deliverables
                  </h4>
                  <ul className="space-y-2" data-id="element-489" data-mp="2ep1cdpj1t5mi">
                    {deliverables.map((item: string, idx: number) => <li key={idx} className="text-sm text-gray-600 flex items-start" data-id="element-490" data-mp="2016iw6x7ux8d" data-mpi={idx}>
                        <span className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-2 mt-1.5" data-id="element-491" data-mp="1qyf1zrlkn99c"></span>
                        {item}
                      </li>)}
                  </ul>
                </div>

                <div data-id="element-492" data-mp="1nvr4se1sv0u7">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center" data-id="element-493" data-mp="1nwapg2iu43bx">
                    <Clock className="h-4 w-4 mr-2 text-blue-600" data-id="element-494" data-mp="1iyiut0qt2341" /> Typical
                    Timeline
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-495" data-mp="1e4whr7gqbx7p">{timeline}</p>
                </div>

                <div data-id="element-496" data-mp="1a3kyrksd2a8h">
                  <h4 className="font-semibold text-gray-900 mb-3" data-id="element-497" data-mp="156b1jiyqcua3">
                    What we need from you
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-498" data-mp="106g93azb3wmx">{requirements}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
  return <div className="pt-10" data-id="element-499" data-mp="r7uwrxkfhdul">
      <div className="bg-gray-50 py-16" data-id="element-500" data-mp="r8mgaa0r3l4i">
        <div className="container-custom text-center" data-id="element-501" data-mp="2pm5xbiwqm53q">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-502" data-mp="2plmr2zgg955j">
            Our Services
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-503" data-mp="2llm4grj75nne">
            Comprehensive corporate solutions tailored to your business needs in
            the UAE.
          </p>
        </div>
      </div>

      <ServiceSection id="corporate" title="Corporate Services Provider" code="7010006" description="We handle the complexities of company formation and structuring, ensuring your business is set up correctly from day one. Our team navigates the regulatory landscape so you can focus on your core business." icon={Building2} features={['Company structuring & setup coordination', 'Corporate documentation support', 'Compliance support coordination', 'Office / flexi-desk coordination support']} idealFor={['New market entrants', 'International subsidiaries', 'Freelancers upgrading to trade licenses', 'Holding companies']} deliverables={['Trade License', 'Memorandum of Association', 'Establishment Card', 'Lease Agreement']} timeline="5-10 working days (subject to approvals)" requirements="Passport copies, photos, and basic business details." data-id="element-504" data-mp="ca1rwsycxnxi" />

      <ServiceSection id="investment" title="Investment in Commercial Enterprises & Management" code="6499001" description="For investors and holding companies, we provide strategic management support and due diligence coordination. We help you oversee your portfolio and ensure operational efficiency." icon={TrendingUp} features={['Commercial opportunity sourcing support', 'Business operations & performance consulting', 'Due diligence support coordination', 'Post-investment management support']} idealFor={['Angel investors', 'Family offices', 'Investment holding companies', 'Serial entrepreneurs']} deliverables={['Opportunity assessment reports', 'Operational KPI dashboards', 'Management review meetings', 'Strategic roadmaps']} timeline="Ongoing engagement or project-based" requirements="Investment criteria, portfolio details, and strategic goals." data-id="element-505" data-mp="3jtofe7l5k4tn" />

      <ServiceSection id="brokerage" title="Commercial Brokers" code="4610010" description="We act as a bridge between businesses, facilitating commercial introductions and deals. Our network helps you find the right partners, suppliers, and clients to grow your business." icon={Users} features={['Commercial introductions', 'Deal facilitation support', 'Negotiation support', 'Vendor and partner screening process']} idealFor={['B2B service providers', 'Trading companies', 'Businesses seeking local partners', 'Distributors']} deliverables={['Qualified introductions', 'Meeting coordination', 'Deal term sheets (drafting support)', 'Partner assessment summaries']} timeline="Variable based on deal complexity" requirements="Target partner profile, value proposition, and commercial terms." data-id="element-506" data-mp="dwzrduuibvaw" />

      <section className="py-20 bg-blue-900 text-white text-center" data-id="element-507" data-mp="wlphftqv1fyp">
        <div className="container-custom" data-id="element-508" data-mp="wo20694fzuct">
          <h2 className="text-3xl font-bold mb-6" data-id="element-509" data-mp="rmma22neqxnk">
            Not sure which service you need?
          </h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-510" data-mp="mv4b1k4y3758">
            Our team can assess your business model and recommend the most
            suitable activity codes and structure.
          </p>
          <Link to="/contact" data-id="element-511" data-mp="1fdi7pgejon2q">
            <Button size="lg" className="bg-white text-blue-900 hover:bg-gray-100 border-none" data-id="element-512" data-mp="1fejm9uurrrp7">
              Speak to an Advisor
            </Button>
          </Link>
        </div>
      </section>
    </div>;
}